// extracted by mini-css-extract-plugin
module.exports = {"llista":"IntroduccioIndividu_llista__VQy5x","introduccioIndividu":"IntroduccioIndividu_introduccioIndividu__2DMY0"};